import { combineReducers } from '@reduxjs/toolkit';
import {
  reducer as calendarReducer,
  reset as resetCalendar
} from 'src/slices/calendar';
import {
  reducer as measurementReducer,
  reset as resetMeasurement
} from 'src/slices/measurement';
import {
  reducer as careteamReducer,
  reset as resetCareteam
} from 'src/slices/careteam';
import {
  reducer as mainDashboardReducer,
  reset as resetMainDashboard
} from 'src/slices/main-dashboard';
import {
  reducer as analyticsReducer,
  reset as resetAnalytics
} from 'src/slices/analytics';
import {
  reducer as userNotifications,
  reset as resetUserNotifications
} from '../slices/user-notifications';
import {
  reducer as limitValuesReducer,
  reset as resetLimitValues
} from '../slices/limit-values';
import {
  reducer as communicationRequestReducer,
  reset as resetCommunicationRequest
} from '../slices/communication-request';
import {
  reducer as patientsProfileReducer,
  reset as resetPatientsProfile
} from '../slices/patients-profile';
import {
  reducer as patientsDetailReducer,
  reset as resetPatientsDetail
} from '../slices/patients-detail';
import {
  reducer as logHistoryReducer,
  reset as resetLogHistory
} from '../slices/log-history';
import {
  reducer as clinicReducer,
  reset as resetClinic
} from '../slices/clinic';
import {
  reducer as medicalInfoReducer,
  reset as resetMedicalInfo
} from '../slices/medical-info';
import {
  reducer as allergyReducer,
  reset as resetAllergy
} from '../slices/allergies';
import {
  reducer as conditionReducer,
  reset as resetCondition
} from '../slices/conditions';
import { chatApi } from '../slices/chat-api';

const rootReducer = combineReducers({
  calendar: calendarReducer,
  measurement: measurementReducer,
  careteam: careteamReducer,
  mainDashboard: mainDashboardReducer,
  conditions: conditionReducer,
  analytics: analyticsReducer,
  userNotifications,
  limitValues: limitValuesReducer,
  communicationRequest: communicationRequestReducer,
  patientsProfile: patientsProfileReducer,
  clinic: clinicReducer,
  medicalInfo: medicalInfoReducer,
  logHistory: logHistoryReducer,
  patientsDetail: patientsDetailReducer,
  allergy: allergyReducer,
  condition: conditionReducer,
  [chatApi.reducerPath]: chatApi.reducer
});

// TODO: Refactor maybe?
export const resetActions = [
  resetCalendar,
  resetMeasurement,
  resetCareteam,
  resetMainDashboard,
  resetAnalytics,
  resetUserNotifications,
  resetLimitValues,
  resetCommunicationRequest,
  resetPatientsProfile,
  resetClinic,
  resetMedicalInfo,
  resetPatientsDetail,
  resetLogHistory,
  resetAllergy,
  resetCondition
];

export default rootReducer;
